import axios from '@/axios'

const state = {
    clientsByEnv: [],
};

const getters = {
    getClientsByEnv: (state) => state.clientsByEnv,
};

const mutations = {
    setClientsByEnv: (state, clientsByEnv) => (state.clientsByEnv = clientsByEnv),
};

const actions = {
    async loadClientsByEnv(context, data) {
        await axios().get(`/getClientsByEnv`).then(response => {
            context.commit('setClientsByEnv', response.data)
        })
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}
